import React from 'react';
import styles from './SuccessMessage.module.css';

const SuccessMessage = ({ title, description }) => (
     <div className={`border-medium py-20 px-20 ${styles.succesBox}`}>
        <h3>{title}</h3>
        <p>{description}</p>
     </div>
  );
  

export default SuccessMessage;